module.exports = __webpack_public_path__ + "static/media/adelaide.3106e803.svg";